import AddCompanyModal from "./AddCompany";

export default AddCompanyModal;
